import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['prev', 'next'];

  navigate(event) {
    if (event.target.matches('input, textarea, select')) return;

    if (event.key === 'ArrowLeft' && this.hasPrevTarget) {
      event.preventDefault();
      this.prevTarget.click();
    } else if (event.key === 'ArrowRight' && this.hasNextTarget) {
      event.preventDefault();
      this.nextTarget.click();
    }
  }
}
